enum SIMDocumentTypeDocumentClass {
    W9 = 1,
    InsuranceCertificate = 2,
    ChangeOfAddress = 3,
    RemittanceInformation = 4,
}

export default SIMDocumentTypeDocumentClass;
